import {
  getSelectDropdownListFloatingConfig,
  SELECT_DROPDOWN_LIST_MAX_HEIGHT_ENTITY,
} from '../../Select'

export const FLAT_ROOM_TYPE_SELECT_DROPDOWN_FLOATING_CONFIG =
  getSelectDropdownListFloatingConfig(SELECT_DROPDOWN_LIST_MAX_HEIGHT_ENTITY)
